
























import Vue, { PropOptions } from 'vue';

import PathContent from '@/components/bots/PathContent.vue';
import { Integration } from '@/models';
import { OmniChatSchema } from '@omnichat/omnichat-model';

export default Vue.extend({
  components: { PathContent },
  props: {
    bot: {
      type: Object,
    } as PropOptions<Integration>,
  },
  data() {
    return {
      statePaths: [] as OmniChatSchema.BotState[],
      paths: {} as OmniChatSchema.BotState,
      componentKey: 0,
    };
  },
  mounted() {
    if (this.bot) {
      this.paths = this.bot.configuration && this.bot.configuration.initialState;
    }

    if (this.paths) {
      this.getStatePathsRec(this.paths as OmniChatSchema.BotState);
    }
  },
  methods: {
    getStatePaths(paths: OmniChatSchema.BotState[]): any {
      if (!paths) {
        return;
      }

      for (const path of paths) {
        this.getStatePathsRec(path);
      }
    },
    getStatePathsRec(path: OmniChatSchema.BotState) {
      if (path.handlerType === OmniChatSchema.BotHandlerType.botStateChangeHandler
        || path.handlerType === OmniChatSchema.BotHandlerType.channelStateChangeHandler
        || path.handlerType === OmniChatSchema.BotHandlerType.sendToChannel) {
        this.statePaths.push(path);
        if (path.toState && path.toState.to) {
          return this.getStatePaths(path.toState.to);
        }
      }
    },
    async onDeletePathItem() {
      await this.$store.commit('setBot', this.bot);
      this.statePaths = [];
      this.getStatePathsRec(this.paths as OmniChatSchema.BotState);
    },
    async onDeletePath(path: any) {
      for (const mainPath of this.statePaths) {
        if (mainPath.toState && mainPath.toState.to) {
          mainPath.toState.to = mainPath.toState.to.filter((p: OmniChatSchema.BotState) => p !== path);
        }
      }

      await this.$store.commit('setBot', this.bot);
      this.statePaths = [];
      this.getStatePathsRec(this.paths as OmniChatSchema.BotState);
    },
    async onSaveBot() {
      await this.$store.commit('setBot', this.bot);
      this.statePaths = [];
      this.getStatePathsRec(this.paths as OmniChatSchema.BotState);
      this.componentKey++;
      this.$emit('save');
    },
  },
  watch: {
    bot(val) {
      if (val && val.configuration) {
        this.paths = this.bot.configuration && this.bot.configuration.initialState;
        this.statePaths = [];
        this.getStatePathsRec(this.paths as OmniChatSchema.BotState);
      }
    },
  },
});
